import { render, staticRenderFns } from "./MainLedgerView.vue?vue&type=template&id=c5ced552&scoped=true"
import script from "./MainLedgerView.vue?vue&type=script&lang=js"
export * from "./MainLedgerView.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerView.vue?vue&type=style&index=0&id=c5ced552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ced552",
  null
  
)

export default component.exports